// extracted by mini-css-extract-plugin
export var arrow = "_33-6";
export var changeItem = "_33-3";
export var changesHeader = "_33-1";
export var changesList = "_33-2";
export var container = "_33-0";
export var pathLabel = "_33-4";
export var value = "_33-7";
export var valuesContainer = "_33-5";